import Span from './Span'

export default Span
